import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';

import photo1 from '../../assets/about/about1.jpg';
import photo2 from '../../assets/about/about2.jpg';
import photo3 from '../../assets/about/about3.jpg';
import photo4 from '../../assets/about/about4.jpg';
import photo5 from '../../assets/about/about5.jpg';
import photo6 from '../../assets/about/about6.jpg';
import photo7 from '../../assets/about/about7.jpg';
import photo8 from '../../assets/about/about8.jpg';
import photo9 from '../../assets/about/about9.jpg';

import aboutVideo from '../../assets/about/PREWED Stanley + Deepika.mp4';

import wwd1 from '../../assets/about/about1.jpg';
import wwd2 from '../../assets/about/about2.jpg';
import wwd3 from '../../assets/about/about3.jpg';
import wwd4 from '../../assets/about/about4.jpg';

const wwdServices = [
  { label: "Wedding Photography", image: wwd1 },
  { label: "Cinematic Videography", image: wwd2 },
  { label: "Baby & Newborn Shoot", image: wwd3 },
  { label: "Maternity Photography", image: wwd4 },

  { label: "Pre-Wedding Shoot", image: wwd1 },
  { label: "Family Portraits", image: wwd2 },
  { label: "Corporate Events", image: wwd3 },
];

export default function AboutUs() {
  const navigate = useNavigate();

  const photo1Ref = useRef(null);
  const photo2Ref = useRef(null);
  const videoRef = useRef(null);

  const hasInteracted = useRef(false);

  const [isMuted, setIsMuted] = useState(true);
  const [wwdActive, setWwdActive] = useState(0);

  useEffect(() => {
    const markInteracted = () => {
      hasInteracted.current = true;
    };

    window.addEventListener('click', markInteracted, { once: true });
    window.addEventListener('scroll', markInteracted, {
      once: true,
      passive: true,
    });
    window.addEventListener('keydown', markInteracted, { once: true });

    const onScroll = () => {
      const scrollY = window.scrollY;

      if (photo1Ref.current) {
        photo1Ref.current.style.transform = `translateY(${scrollY * 0.08}px)`;
      }

      if (photo2Ref.current) {
        photo2Ref.current.style.transform = `translateY(${scrollY * -0.05}px)`;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!videoRef.current) return;

        if (entry.isIntersecting) {
          if (hasInteracted.current) {
            videoRef.current.muted = false;

            videoRef.current
              .play()
              .then(() => setIsMuted(false))
              .catch(() => {
                videoRef.current.muted = true;
                videoRef.current.play();
                setIsMuted(true);
              });
          } else {
            videoRef.current.muted = true;

            videoRef.current.play().catch(() => {});

            setIsMuted(true);
          }
        } else {
          videoRef.current.pause();
          videoRef.current.muted = true;
          setIsMuted(true);
        }
      },
      { threshold: 0.5 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      window.removeEventListener('click', markInteracted);
      window.removeEventListener('scroll', markInteracted);
      window.removeEventListener('keydown', markInteracted);
      window.removeEventListener('scroll', onScroll);

      observer.disconnect();
    };
  }, []);

  const toggleMute = () => {
    if (!videoRef.current) return;

    const newMuted = !isMuted;

    videoRef.current.muted = newMuted;

    if (!newMuted) {
      videoRef.current.play().catch(() => {});
    }

    setIsMuted(newMuted);
  };

  const facts = [
    {
      label:
        'Crafting timeless memories through photography and cinematic storytelling.',
      value: '13+ YEARS OF EXPERIENCE',
    },
    {
      label:
        'From weddings and receptions to traditional and family celebrations.',
      value: '1000+ EVENTS CAPTURED',
    },
    {
      label:
        'Trusted by hundreds of families for preserving their most valuable moments.',
      value: '100% HAPPY CLIENTS',
    },
    {
      label:
        'Capturing emotions across Tamil Nadu with creativity and passion.',
      value: 'BASED IN NAGERCOIL',
    },
    {
      label:
        'Blending natural emotions with modern visual aesthetics.',
      value: 'CINEMATIC STORYTELLING',
    },
    {
      label:
        'Every frame is designed to feel elegant, emotional, and unforgettable.',
      value: 'PREMIUM WEDDING EXPERIENCE',
    },
  ];

  return (
    <>
      {/* SECTION 1 */}
      <div className="about-page">
        <div className="about-left">
          <div className="about-photo-top" ref={photo1Ref}>
            <img src={photo1} alt="Studio work" />
          </div>

          <div className="about-intro">
            <p className="about-sub-label">Photography Studio</p>

            <h1 className="about-name">
              BRAND
              <br />
              PARTNERS
            </h1>

            <p className="about-bio">
              We're a passionate photography studio based in Kanniyakumari,
              Tamil Nadu, and we travel for destination shoots worldwide.
              Our approach combines editorial precision with a focus on real,
              unscripted moments — capturing memories that feel stylish and
              authentic.
            </p>
          </div>
        </div>

        <div className="about-right">
          <div className="about-traits">
            <span>QUIET OBSERVER</span>
            <span>STORYTELLER</span>
            <span>DETAIL-DRIVEN</span>
            <em>Modern romantic</em>
          </div>

          <div className="about-photos-stack">
            <div className="about-photo-main" ref={photo2Ref}>
              <img src={photo2} alt="Team" />
            </div>

            <div className="about-photo-secondary">
              <img src={photo3} alt="Wedding" />
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 2 */}
      <div className="about-video-section">
        <video
          ref={videoRef}
          className="about-video-bg"
          muted
          loop
          playsInline
        >
          <source src={aboutVideo} type="video/mp4" />
        </video>

        <div className="about-video-overlay" />

        <button
          className="about-video-sound-btn"
          onClick={toggleMute}
        >
          {isMuted ? 'SOUND ON' : 'MUTE'}
        </button>

        <div className="about-video-content">
          <blockquote className="about-quote">
            "Every love story deserves to be told with honesty,
            beauty, and a little bit of magic."
          </blockquote>

          <p className="about-quote-author">
            BRAND PARTNERS STUDIO
          </p>
        </div>
      </div>

      {/* SECTION 3 */}
      <div className="about-facts-section">
        <h2 className="about-facts-heading">
          The Art Behind Every <span>Celebration</span>
        </h2>

        <div className="about-facts-card">
          <div className="about-facts-img about-facts-img--left">
            <img src={photo5} alt="Photography" />
          </div>

          <div className="about-facts-grid">
            {facts.map((fact, i) => (
              <div
                key={i}
                className="about-fact-item"
                style={{ animationDelay: `${0.12 * i}s` }}
              >
                <span className="about-fact-label">
                  {fact.label.toUpperCase()}
                </span>

                <em className="about-fact-value">
                  {fact.value}
                </em>
              </div>
            ))}
          </div>

          <div className="about-facts-img about-facts-img--right">
            <img src={photo6} alt="Wedding" />
          </div>
        </div>
      </div>

      {/* SECTION 4 */}
      <div className="wwd-section">
        <div className="wwd-photo-wrap">
          {wwdServices.map((service, index) => (
            <img
              key={index}
              src={service.image}
              alt={service.label}
              className={`wwd-photo ${
                index === wwdActive ? 'wwd-photo--active' : ''
              }`}
            />
          ))}
        </div>

        <div className="wwd-menu">
          <p className="wwd-eyebrow">
            W H A T &nbsp; W E &nbsp; D O
          </p>

          <ul className="wwd-list">
            {wwdServices.map((service, index) => (
              <li
                key={index}
                className={`wwd-item ${
                  index === wwdActive ? 'wwd-item--active' : ''
                }`}
                onMouseEnter={() => setWwdActive(index)}
                onClick={() => setWwdActive(index)}
              >
                {service.label}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* SECTION 5 */}
      <div className="lc-section">
        <div className="lc-photo-left">
          <img src={photo8} alt="Wedding moment" />
        </div>

        <div className="lc-center">
          <div className="lc-center-img">
            <img src={photo7} alt="Bride" />

            <div className="lc-overlay">
              <h2 className="lc-heading">LETS' CONNECT</h2>

              <p className="lc-sub">
                I can't wait to hear your story and capture your
                special day. Drop me a message and let's create
                something amazing together!
              </p>

              <button
                className="lc-btn"
                onClick={() => navigate('/contact')}
              >
                CONTACT ME
              </button>
            </div>
          </div>
        </div>

        <div className="lc-photo-right">
          <img src={photo9} alt="Wedding portrait" />
        </div>
      </div>
    </>
  );
}